import {Typography} from "@material-ui/core";
import * as React from "react";
import {LicenseGroup} from "../../../../../models/LicenseListModel";
import ChipSelect from "../../../../form/select/ChipSelect";

export interface Props {
    title: string;
    caption?: string;
    licenseGroups: LicenseGroup[];
    onGroupSelected?: (group: LicenseGroup) => void;
}

export function LicenseGroupSection({ title, caption, licenseGroups, onGroupSelected }: Props) {
    return (
        <div>
            <Typography variant='subtitle2'>{title}</Typography>

            {caption && (
                <Typography variant='caption'>{caption}</Typography>
            )}

            <div>
                <ChipSelect items={licenseGroups}
                            label={(group) => `${group.application.name} (${group.licenses.length})`}
                            onItemSelected={group => {
                                if (onGroupSelected) {
                                    onGroupSelected(group)
                                }
                            }}/>
            </div>
        </div>
    )
}
